import { Container } from '@mui/material';
import { ChallengeDetail } from 'components/templates';
import React from 'react';
import { useParams } from 'react-router-dom';

export const ChallengeDetailView = () => {
  const { challengeId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <ChallengeDetail id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
